import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { CollapsibleTrigger, type CollapsibleTriggerProps } from 'reka-ui';
    import { ChevronDown } from 'lucide-vue-next';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollapsibleTrigger',
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  setup(__props: any) {

    const props = __props;

    const delegatedProps = reactiveOmit(props, 'class');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CollapsibleTrigger), _mergeProps({ "data-slot": "collapsible-trigger" }, props, {
    class: 
            _unref(cn)(
                'focus-visible:border-ring focus-visible:ring-ring/50 hover:text-primary flex w-full flex-1 cursor-pointer items-start justify-between gap-4 rounded-md p-2 text-left text-xs font-medium transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180',
                props.class,
            )
        
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        _createVNode(_unref(ChevronDown), { class: "text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200" })
      ])
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})